import { render, staticRenderFns } from "./CostBill.vue?vue&type=template&id=f6a55b00&scoped=true"
import script from "./CostBill.vue?vue&type=script&lang=js"
export * from "./CostBill.vue?vue&type=script&lang=js"
import style0 from "./CostBill.vue?vue&type=style&index=0&id=f6a55b00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a55b00",
  null
  
)

export default component.exports